import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-info-label',
  imports: [TranslateModule],
  templateUrl: './info-label.component.html',
  styleUrl: './info-label.component.scss',
})
export class InfoLabelComponent {
  label = input.required<string>();
}
